import { connect } from "react-redux";
import get from "lodash/get";

import { updateProspect } from "../../../../store/actions/appConfig";
import { getOrgKYCDetails } from "../../../../store/selectors/appConfig";

import { CompanyBankingRelationshipsComponent } from "./CompanyBankingRelationships";
import { initialoutSideUAE, initialBankLoan } from "./constants";
import { getIsEditableStatusSearchInfo } from "../../../../store/selectors/searchProspect";

const mapDispatchToProps = {
  updateProspect
};

const mapStateToProps = state => ({
  outsideUAE: get(
    getOrgKYCDetails(state),
    "otherBankingRelationshipsInfo.bankDetailsOutsideUAE",
    initialoutSideUAE
  ),
  bankLoan: get(
    getOrgKYCDetails(state),
    "otherBankingRelationshipsInfo.otherBankLoanRelationship",
    initialBankLoan
  ),
  orgKYCDetails: getOrgKYCDetails(state),
  withinUAE: get(
    getOrgKYCDetails(state),
    "otherBankingRelationshipsInfo.bankDetailsInUAE"
    //initialWithinUAE
  ),
  isComeFromROScreens: getIsEditableStatusSearchInfo(state)
});

export const CompanyBankingRelationships = connect(
  mapStateToProps,
  mapDispatchToProps
)(CompanyBankingRelationshipsComponent);
